import request from "@/utils/request";
import ds, { dsc, ___ } from '../utils/daoService/DaoServiceClientES6Adapter'

const ebBlPlans = ds.QEbBlPlan.using(dsc);
const ebOrder = ds.QEbOrder.using(dsc);

//提单管理查询
export function getBillManage(data) {
  return request({
    url: '/web/billEdit/getBillManage',
    method: 'post',
    data
  });
}
//提单编辑查询
export function getBillEdit(data) {
  return request({
    url: '/web/billEdit/getBillEdit',
    method: 'post',
    data
  });
}

export function queryPackageCode(data) {
  return request({
    url: '/web/billEdit/queryPackageCode',
    method: 'post',
    data
  });
}

export function queryManageMentList(searchData) {
  return ebOrder.select(ebOrder.fieldContainer()
    .append(ebOrder.ebBlPlan.chain(ebBlPlans.docStatus))
    .append(ebOrder.ebBlPlan.chain(ebBlPlans.approvalStatus))
    .append(ebOrder.ebBlPlan.chain(ebBlPlans.creatorName))
    .append(ebOrder.ebBlPlan.chain(ebBlPlans.createTime)))
    .paging(searchData.page, searchData.limit)
    .where(searchData.whereObj)
    .tag('queryEbOrderEbBlPlan')
    .execute(searchData.valueObj)
}

export function queryStatusCount(approvalStatus) {
  if (!approvalStatus) {
    return ebBlPlan
      .select(ebBlPlan.ebBlPlanId)
      .where(ebBlPlan.approvalStatus.notNull())
      .tag('queryStatusCount')
      .execute()
  } else {
    return ebBlPlan
      .select(ebBlPlan.ebBlPlanId)
      .where(ebBlPlan.approvalStatus.eq$(approvalStatus))
      .tag('queryStatusCount')
      .execute()
  }
}

// 简单查询+订单状态
export function queryEbOrder(searchData) {
  return ebOrder
    .select(ebOrder.fieldContainer())
    .where(ebOrder.orderNo._like$_(searchData.arrayNo)
      .or(ebOrder.custBizNo._like$_(searchData.arrayNo))
      .or(ebOrder.mblNo._like$_(searchData.arrayNo))
      .and(ebOrder.orderStatus._like$_(searchData.orderStatus))
      .and(ebOrder.transferStatus.ne$(1)))
    .paging(searchData.page, searchData.limit)
    .tag('queryEbOrder')
    .execute(searchData)
}
// 多条件
export function queryEbOrderMore(searchData) {
  return ebOrder
    .select(ebOrder.fieldContainer())
    .where(ebOrder.orderNo.in$(searchData.arrayNo)
      .or(ebOrder.custBizNo.in$(searchData.arrayNo))
      .or(ebOrder.mblNo.in$(searchData.arrayNo))
      .and(ebOrder.orderStatus._like$_(searchData.orderStatus))
      .and(ebOrder.transferStatus.ne$(1)))
    .paging(searchData.page, searchData.limit)
    .tag('queryEbOrder')
    .execute(searchData)
}

// 高级查询+订单状态
export function queryMoreEbOrder(searchData) {
  return ebOrder
    .select(ebOrder.fieldContainer())
    .where(searchData.whereObj)
    .paging(searchData.page, searchData.limit)
    .tag('queryMoreEbOrder')
    .execute(searchData.valueObj)
}

export function ladinBillManageListExport(searchData) {
  ds.otherClient
    .forCustomExport()
    // .tag('CTS_WEB_LadinBillManageListExport')
    .async(false)
    .customSqlKey('CTS_WEB_LadinBillQqueryManageMentList')
    .execute(searchData)
}

export function uploadTest(formData) {
  return request.post(
    '/web/ladinBill/uploadTest',
    formData,
    { contentType: 'multipart/form-data' }
  )
}
